import { Component, OnInit } from '@angular/core';
import { BreadcrumbService } from 'ng-breadcrumb';

@Component({
  selector: 'app-counseling-guidance',
  templateUrl: './counseling-guidance.component.html',
  styleUrls: ['./counseling-guidance.component.scss']
})
export class CounselingGuidanceComponent implements OnInit {

  constructor(private breadcrumbService: BreadcrumbService) { }

  ngOnInit(): void { 
    this.breadcrumbService.addFriendlyNameForRoute('/consiliere-si-orientare-cariera', 'Consiliere si orientare in cariera')
  }

}
